import React, { useState } from 'react'
import { Divider, message, Popconfirm, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

import EditUserModal from './EditUserModal'
import { deleteUser } from '../services'
import { handleError } from '../../../helpers'

export default function UsersTable({ users, reload }) {
	const [editUser, setEditUser] = useState(null)

	const handleDelete = id => {
		deleteUser(id)
			.then(() => {
				message.success('Usuario Eliminado Exitosamente')
				reload()
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Nombre Completo',
			dataIndex: 'name'
		},
		{
			title: 'Documento',
			dataIndex: 'document'
		},
		{
			title: 'Email',
			dataIndex: 'email'
		},
		{
			title: 'Rol',
			dataIndex: 'role',
			render: t => t === 'agent' ? 'Transportador' : t === 'admin' ? 'Administrador' : 'Super Admin'
		},
		{
			title: 'Estado',
			dataIndex: 'active',
			render: t => t === 1 ? 'Activo' : 'Inactivo'
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Tooltip title="Editar Usuario">
						<FontAwesomeIcon className="text-link" icon={faEdit} onClick={()=>setEditUser(record)} />
					</Tooltip>
					{ record.role === 'agent' && (
						<React.Fragment>
							<Divider type="vertical" />
							<Popconfirm 
								title="¿Desea eliminar el usuario?"
								okText="Eliminar"
								cancelText="Cancelar"
								onConfirm={() => handleDelete(record.id)}
								okButtonProps={{ danger:true }}
							>
								<FontAwesomeIcon className="text-link" icon={faTrash} />
							</Popconfirm>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	return (
		<React.Fragment>
			<Table 
				dataSource={users}
				columns={columns}
				rowKey={record => record.id}
			/>
			<EditUserModal 
				visible={editUser ? true : false}
				onClose={()=>setEditUser(null)}
				user={editUser}
				reload={reload}
			/>
		</React.Fragment>
	)
}